import { createTheme } from '@mui/material/styles';

const defaultTheme = createTheme();

const paletteByMode = {
    light: {
        mode: 'light',
        primary: { main: '#3E9CD9' },
        secondary: { main: '#2d3748' },
        background: { default: '#F6F6F6', paper: '#FFFFFF' },
        text: { primary: '#333333', secondary: '#7D8696' },
        divider: '#E9E9E9',
    },
    dark: {
        mode: 'dark',
        primary: { main: '#56ACE3' },
        secondary: { main: '#B8C0CC' },
        background: { default: '#14171D', paper: '#1B1F27' },
        text: { primary: '#EDEFF2', secondary: '#9AA6B5' },
        divider: '#262B34',
    },
};

const getAppTheme = (mode) =>
    createTheme({
        typography: {
            fontFamily: "'Saira', Roboto, sans-serif; !important",
        },
        palette: {
            ...paletteByMode[mode],
            danger: defaultTheme.palette.augmentColor({
                color: { main: '#ED7571', contrastText: '#fff' },
                name: 'danger',
            }),
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    contained: {
                        boxShadow: 'none',
                        '&:hover': {
                            boxShadow: '0 2px 6px rgba(0, 74, 128,.25)',
                        },
                    },
                    containedPrimary: {
                        color: '#FFF',
                    },
                },
            },
            MuiLinearProgress: {
                styleOverrides: {
                    colorPrimary: {
                        height: '2px',
                    },
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    input: {
                        padding: 14,
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    elevation1: {
                        boxShadow:
                            mode === 'dark'
                                ? '0 2px 8px rgba(0,0,0,.35)'
                                : '0 2px 8px rgba(31,45,61,.05)',
                    },
                },
            },
            MuiMenuItem: {
                styleOverrides: {
                    root: {
                        paddingTop: 12,
                        paddingBottom: 12,
                        minHeight: 45,
                        fontSize: '0.9rem',
                    },
                },
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        padding: '3px',
                    },
                },
            },
            MuiTableRow: {
                styleOverrides: {
                    root: {
                        '&:last-child td': {
                            borderBottom: 0,
                        },
                    },
                },
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: { width: '1.9rem' },
                },
            },
            MuiListItem: {
                styleOverrides: {
                    gutters: {
                        paddingLeft: 0,
                    },
                },
            },
            MuiDialog: {
                styleOverrides: {
                    paperFullWidth: {
                        background: paletteByMode[mode].background.paper,
                        boxShadow:
                            mode === 'dark'
                                ? '0px 0px 60px rgba(0, 0, 0, 0.5)'
                                : '0px 0px 60px rgba(0, 0, 0, 0.1)',
                        borderRadius: '20px',
                    },
                },
            },
            MuiFormHelperText: {
                styleOverrides: {
                    root: {
                        fontFamily: "'Saira', Roboto, sans-serif; !important",
                    },
                },
            },
            MuiFormLabel: {
                styleOverrides: {
                    root: {
                        fontFamily: "'Saira', Roboto !important",
                    },
                },
            },
            MuiTextField: {
                variants: [{ props: { variant: 'base' } }],
            },
        },
    });

export default getAppTheme;
